import type { PullRequestRef } from "@cmmd-forge/contracts";

import type { PullRequestRightPanelSurface, RightPanelSurface } from "~/rightPanelSurface";

export function findActivePullRequestSurface(
  surfaces: readonly RightPanelSurface[],
  activeSurfaceId: string | null,
): PullRequestRightPanelSurface | null {
  return (
    surfaces.find(
      (surface): surface is PullRequestRightPanelSurface =>
        surface.id === activeSurfaceId && surface.kind === "pull-request",
    ) ?? null
  );
}

export function pullRequestReferenceFromSurface(
  surface: PullRequestRightPanelSurface,
): PullRequestRef {
  return {
    projectId: surface.projectId,
    ...(surface.repositoryLinkId === null
      ? {}
      : { projectRepositoryId: Number(surface.repositoryLinkId) }),
    repository: surface.repository,
    number: surface.number,
  };
}
